import {Injectable} from "@angular/core";
import {UrlsResources} from "../urls-resources";
import {HttpClient, HttpHeaders, HttpParams} from "@angular/common/http";
import {Observable} from "rxjs/Observable";
import {AuthService} from "../auth/auth.service";
import {HandleError} from '../handle-error';
import {RequestOptions} from "@angular/http";
import {Form} from "@angular/forms";
import {ReferInfo} from "./refer-info";
import {PromocionInfo} from "../promociones/promocion-info";
import {ReferInfoResponse} from "./refer-info-response";

@Injectable()
export class ReferralsService {
    constructor(protected httpClient: HttpClient,
                private authService: AuthService,
                private handleError: HandleError,
                protected urlsResources: UrlsResources) {
    }

    getRefersList(): Observable<ReferInfoResponse[]> {
        return this.httpClient.get<ReferInfoResponse[]>(this.urlsResources.getRefersUrl(), {withCredentials: true});
    }

    activeRefer(refer: ReferInfo): Observable<void> {
        return this.httpClient.post<void>(this.urlsResources.changeStatusReferUrl(), {
            referralKey: refer.referralKey,
            active: !refer.active
        }, {withCredentials: true});
    }

  getUrls(): Observable<any> {
    return this.httpClient.get(this.urlsResources.getUrls(), {withCredentials: true});
  }

  saveReferral(model: any): Observable<any>{
    return this.httpClient.post(this.urlsResources.saveReferral(), model, {withCredentials: true}); 
  }

  pathcReferral(model: any): Observable<any>{
    return this.httpClient.patch(this.urlsResources.saveReferral(), model, {withCredentials: true}); 
  }

  getReferByKey(referralKey: string): Observable<any>{
    return this.httpClient.get(this.urlsResources.getReferByKey(referralKey), {withCredentials: true});
  }

}



// WEBPACK FOOTER //
// /codebuild/output/src14910448/src/src/app/core/referrals/referrals.service.ts